import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { VStack, Box } from '@chakra-ui/react';
import { CardCarousel, CardCarouselProps } from '@src/components/sco/CardCarousel';
import { TopControlTest } from '@src/components/sco/CardCarousel/Controls/TopControlTest';
import { ArticleCard } from '@src/components/sco/Education/ArticleLanding/ArticleCard';
import { gql } from '@src/lib/gql';
import React from 'react';
type ArticleListCarouselProps = {
  articleType: 'ExpertAdvice' | 'FounderStory' | 'BlogPost';
  typeSlug?: string;
  subjectLogo?: string;
  term?: string;
  twoCard?: boolean;
  oneCard?: boolean;
  carouselProps?: CardCarouselProps;
};
export const ArticleListCarousel: React.FC<ArticleListCarouselProps> = props => {
  const $ = _c(15);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = gql`
      query ($type: ArticleType!, $termSlug: String!) {
        articles(first: 8, where: { type: $type, terms_some: { slug: $termSlug } }, orderBy: createdAt_DESC) {
          id
          title
          slug
          subjectNames
          synopsis
          teaser
          seoDescription
          subjectLogos {
            id
            url
          }
          terms {
            id
            name
            slug
            color {
              hex
            }
          }
          featuredImage {
            id
            url(transformation: { image: { resize: { fit: max, width: 1000 } } })
          }
          authors {
            firstName
            lastName
            avatar {
              url
            }
          }
        }
      }
    `;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = props.articleType || "ExpertAdvice";
  const t2 = props.term || "featured";
  let t3;
  if ($[1] !== t1 || $[2] !== t2) {
    t3 = {
      variables: {
        type: t1,
        termSlug: t2
      }
    };
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const articleQuery = useQuery(t0, t3);
  const article = articleQuery.data?.articles[0];
  if (!article) {
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <></>;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    return t4;
  }
  let t4;
  if ($[5] !== articleQuery.error) {
    t4 = articleQuery.error && <p>{"Error: "}{articleQuery.error.message}</p>;
    $[5] = articleQuery.error;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== article || $[8] !== articleQuery.data || $[9] !== props.carouselProps || $[10] !== props.typeSlug) {
    t5 = articleQuery.data && <CardCarousel spacing={6} title={article.terms && article.terms[0]?.name} visibleCards={[1, 1, 2, 3, 3, 4]} controls={{
      top: TopControlTest,
      bottom: false
    }} fade={{
      startColor: "transparent",
      endColor: "#1F2128"
    }} {...props.carouselProps}>{articleQuery.data?.articles.map(article_0 => <ArticleCard key={article_0.id} authors={true} avatar={article_0.authors[0]?.avatar?.url} firstName={article_0.authors[0]?.firstName} image={article_0.featuredImage?.url} lastName={article_0.authors[0]?.lastName} subject={article_0.subjectNames.join(", ")} subjectLogo={article_0.subjectLogos[0]?.url} summary={article_0.seoDescription} title={article_0.title} url={`/${props.typeSlug || "articles"}/${article_0.slug}`} />)}</CardCarousel>;
    $[7] = article;
    $[8] = articleQuery.data;
    $[9] = props.carouselProps;
    $[10] = props.typeSlug;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <VStack align="center" borderTopRadius="lg" height="full" justify="center" position="relative" width="full"><Box width="full">{t4}{t5}</Box></VStack>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};